<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/E4RNzN/tc-custom/9781455621170.jpg?1738389451914" alt="This image is the cover for the book Ghost Hunter's Guide to Portland and Oregon Coast"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Ghost Hunter's Guide to Portland and Oregon Coast
      </h1>
      <p class="bookDescription body article font2">
        <p>Ghosts and spirits abound in western Oregon. The imprints of pioneers, soldiers, prostitutes, and murder victims haunt the places they trod in life, searching for loved ones, reliving joyful times, protecting favorite haunts, and seeking revenge. This guide, history, and comprehensive how-to offers tantalizing information about the lives, deaths, and locales of the Portland area’s lingering past.</p><p>Areas include Central Portland, East Portland communities, Vancouver and North Portland, communities south of Portland, and Oregon’s coastal communities. The infamous Shanghai Tunnels have long reverberated with the screams of kidnapped victims, doomed to a brief life of forced servitude. Lone Fir Cemetery is visited to this day by the spirits of the Chinese laborers, mental asylum inmates, and Civil War veterans who rest there. Thelma Taylor can sometimes be felt in Cathedral Park, under the St. John Bridge. Historical hotels still host the spirits of guests who died, sometimes by their own hand. Opera houses and ballrooms tell a happier story: the imprints left by decades of entertainment and energy can be felt even now. These sites, and many others, are vividly described, and entries include locations and contact information.</p><p>Informative sections cover what a ghost is, how it can manifest, ideal ghost sighting conditions, and types of imprints. Techniques included are preliminary historical research, physical and mental preparation, and the two primary schools of ghost hunting: the technical and psychic methods. The technical method section covers equipment use and suggestions, and the psychic method section discusses using your intuition and sensitivity to sense phenomena. Helpful appendixes include a sighting report form; suggested readings, videos, and websites; a list of tours and events; and a collection of area museums and historical societies.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jeff Dwyer
      </h2>
      
      <p class="authorDescription body article">A paranormal investigator and expert ghost hunter, Jeff Dwyer researches ghostly phenomena using highly developed psychic methods that include clairvoyance, remote viewing, and psychometry. He lives in Fairfield, California.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Pelican Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?65247df6